import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {_SCREEN_SHARE_STORE, MUTATIONS} from '../values/screen-share.values';
import log from 'js-logger';

export const SCREEN_SHARE_STORE = _SCREEN_SHARE_STORE;

@Module({ namespaced: true })
export class ScreenShareStore extends VuexModule {

  public screenShareConfig: any = {};
  public localIsOnScreenShare: boolean = false;
  public remoteIsOnScreenShare: boolean = false;
  public isMuted: boolean = false;
  public meet: any = {};
  public videoSrc: any;
  public videoSrcId: string;

  public conference: any = {};


  /* Mutations */

  @Mutation
  public cleanScreenShareStarted(){
    this.localIsOnScreenShare = false;
    this.screenShareConfig = {};
    this.isMuted = false;
    this.videoSrc = null;
    this.videoSrcId = null;
    this.meet = {};
    this.conference = {};
  }
  

  @Mutation
  public updateConference(conference:any){
    Object.assign(this.conference, conference);
  }

  @Mutation
  public cleanConference(conference:any){
    this.conference = conference;
  }

  @Mutation
  public updateScreenShareConfig({domain, username, meetingId, classId, sessionId}:{domain:string,username:string,meetingId:string,classId:string,sessionId:string}) : void {
    this.screenShareConfig = { domain, username, meetingId, classId, sessionId };
  }


  @Mutation
  public updateLocalIsOnScreenShare(isOnScreenShare:boolean) : void {
    this.localIsOnScreenShare = isOnScreenShare;
  }

  @Mutation
  public updateRemoteIsOnScreenShare(isOnScreenShare:boolean) : void {
    this.remoteIsOnScreenShare = isOnScreenShare;
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.localIsOnScreenShare = false;
    this.screenShareConfig = {};
    this.isMuted = false;
    this.videoSrc = null;
    this.videoSrcId = null;
    this.meet = {};
    this.conference = {};
  }

}
